import { Button, Form, Input, InputNumber, Modal, Upload, message } from 'antd';
import { InboxOutlined, PlusOutlined, SaveOutlined } from '@ant-design/icons';
import TextArea from 'antd/es/input/TextArea';
import styles from 'styles/components/rewardForm.module.scss';
import { addReward, updateReward } from 'utils/api';
import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ProfileContext from './profileContext';
import { getBase64 } from 'utils/utils';
import { CLOUDINARY } from 'utils/constants';
import RewardListContext from './rewardListContext';

const normFile = (e) => {
  if (Array.isArray(e)) {
    return e;
  }
  return e?.fileList;
};

const RewardForm = ({ initialValues }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  // const [isUploading, setIsUploading] = useState(false);
  const [image, setImage] = useState({});
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const navigate = useNavigate();
  const { profile } = useContext(ProfileContext);
  const { updateRewards } = useContext(RewardListContext);
  const initValues = {
    amount: 1,
    ...(initialValues || {}),
  };
  const isEdit = !!initialValues;

  const onFinish = (values) => {
    setLoading(true);
    const functionToUse = isEdit ? updateReward : addReward;
    const params = {
      ...values,
      ...(image && image.picUrl ? { image: image.picUrl } : {}),
      ...(isEdit ? { rewardId: initialValues._id } : {}),
      live: values.live !== undefined ? values.live : true,
    };
    functionToUse(params)
      .then((data) => {
        updateRewards();
        message.success(
          <span>
            <b>{data.title}</b>
            {` was ${isEdit ? 'updated' : 'created'} succesfuly`}
          </span>
        );
        // form.resetFields();
        setTimeout(() => {
          navigate('/rewards');
        }, 500);
      })
      .catch((e) => {
        console.error(e);
        message.error('Error while creating the reward, try again.');
      });
  };

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
    }
    const isLt1M = file.size / 1024 / 1024 < 1;
    if (!isLt1M) {
      message.error('Image must be smaller than 1MB');
    }
    return isJpgOrPng && isLt1M;
  };

  const onChangeUpload = (info) => {
    if (info.file.status === 'uploading') {
      // setIsUploading(true);
      return;
    }
    if (info.file.status === 'done') {
      getBase64(info.file.originFileObj, (imageUrl) => {
        // setIsUploading(false);
        setImage({ imageUrl, picUrl: info.file.response.secure_url });
      });
    }
    if (info.file.status === 'error') {
      message.error('Error while uploading, please try again.');
      // setIsUploading(false);
      setImage({ imageUrl: null });
    }
  };

  return (
    <>
      <Form
        form={form}
        layout={'vertical'}
        name="control-hooks"
        onFinish={onFinish}
        style={{ maxWidth: 600 }}
        initialValues={initValues}
      >
        <Form.Item name="title" label="Name" rules={[{ required: true }]}>
          <Input placeholder="Name the reward" />
        </Form.Item>
        <Form.Item
          name="description"
          label="Description"
          rules={[{ required: true }]}
        >
          <TextArea rows={4} placeholder="Describe what's in it." />
        </Form.Item>
        <Form.Item name="amount" label="Price 👏" rules={[{ required: true }]}>
          <InputNumber min={1} />
        </Form.Item>
        <Form.Item
          label="Upload a picture of the reward (squared pictures work best):"
          valuePropName="image"
          getValueFromEvent={normFile}
        >
          <Upload
            beforeUpload={beforeUpload}
            onChange={onChangeUpload}
            maxCount={1}
            data={{
              upload_preset: CLOUDINARY.UPLOAD_PRESETS,
            }}
            listType="picture-card"
            action={`https://api.cloudinary.com/v1_1/${CLOUDINARY.CLOUD_NAME}/upload`}
          >
            <div>
              <PlusOutlined />
              <div style={{ marginTop: 8 }}>Upload</div>
            </div>
          </Upload>
        </Form.Item>
        <Form.Item>
          <Button
            block
            size="large"
            type="primary"
            htmlType="submit"
            icon={isEdit ? <SaveOutlined /> : <PlusOutlined />}
            loading={loading}
          >
            {isEdit ? 'Save changes' : 'Add reward'}
          </Button>
        </Form.Item>
        {profile.isAdmin && isEdit && (
          <>
            <div className={styles.archiveWrapper}>
              <Button
                className={styles.archiveBtn}
                block
                type="primary"
                ghost
                danger
                icon={<InboxOutlined />}
                onClick={() => setShowConfirmDelete(true)}
              >
                Delete
              </Button>
              <div className={styles.archiveHint}>
                <span>Deleting the reward will remove it from the list instantly</span>
              </div>
            </div>
            <Modal
              onCancel={() => {
                setShowConfirmDelete(false);
              }}
              open={showConfirmDelete}
              title={'Confirm delete'}
              footer={[
                <Button onClick={() => setShowConfirmDelete(false)}>
                  Cancel
                </Button>,
                <Button
                  type="primary"
                  danger
                  onClick={() => {
                    onFinish({ ...initialValues, live: !initialValues.live });
                  }}
                >
                  Delete it
                </Button>,
              ]}
            >
              {'Please confirm that you want to delete this reward.'}
            </Modal>
          </>
        )}
      </Form>
    </>
  );
};

export default RewardForm;
